<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'USERS', url: '/admin/users' },
    { label: 'USER_DETAILS' }
  ]"
></breadcrumbs>
<page-header title="USER_DETAILS"></page-header>

<card>
  <table class="table is-fullwidth">
    <tbody>
      <tr>
        <td>
          <b translationEditableDirective="ID">{{ 'ID' | translate }}</b
          >: {{ state.get('id') }}
        </td>
      </tr>
      <tr>
        <td>
          <b translationEditableDirective="FIRST_NAME">{{
            'FIRST_NAME' | translate
          }}</b
          >: {{ state.get('firstName') }}
        </td>
      </tr>
      <tr>
        <td>
          <b translationEditableDirective="LAST_NAME">{{
            'LAST_NAME' | translate
          }}</b
          >: {{ state.get('lastName') }}
        </td>
      </tr>
      <tr>
        <td>
          <b translationEditableDirective="EMAIL">{{ 'EMAIL' | translate }}</b
          >: {{ state.get('email') }}
        </td>
      </tr>
      <tr>
        <td>
          <b translationEditableDirective="RILES">{{ 'RILES' | translate }}</b
          >:
          {{ sanitizeRoles(state.get('roles')) }}
        </td>
      </tr>
    </tbody>
  </table>
</card>
